import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProjectItemRevisionModel from "../../../models/ProjectItemRevisionModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ItemRevisionPopupProps extends PopupProps {
    projectItemRevision: ProjectItemRevisionModel
    itemTypeId: number
}

const ChangeItemNrPopup: React.FC<ItemRevisionPopupProps> = ({ show, onHide, projectItemRevision, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectItemRevisionModel>();

    const projects = useSelectListOptions('api/v1/selectlist/Projects?activeOnly=true&itemTypeId=' + itemTypeId, '-- Select project');

    useEffect(() => {
        setFormData(projectItemRevision)
    }, [projectItemRevision])

    function submit() {
        if (formData) {
            DataService
                .update(`api/v1/ProjectItemRevisions`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectId', label: 'Project', validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Move to another project'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('projectId')} options={projects} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default ChangeItemNrPopup;